/* eslint no-unused-vars: 0 */

import React from "react"

class AdminSearchModal extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    var display;
    if (this.props.display === true) {
      display = (
        <div className="admin--modal">
          <div className="admin--modal--content">
            <div className="admin--modal-title">
              <h1>{this.props.title}</h1>
            </div>
            <div className="admin--modal-body">
              <p>{this.props.body}</p>
            </div>
            <a
              className="btn"
              onClick={() => {
                this.props.close(false);
              }}
            >
              {this.props.closeTitle}
            </a>
            <a className="btn action" onClick={this.props.action}>
              {this.props.actionTitle}
            </a>
          </div>
        </div>
      );
    } else {
      display = null;
    }
    return <div>{display}</div>;
  }
}

export default AdminSearchModal;
